'use client'

import { useCallback } from 'react'
import posthog from 'posthog-js'

interface TrackingProps {
  section?: string
  action?: string
  button_name?: string
  destination?: string
  conversion?: boolean
  [key: string]: any
}

export function useButtonTracking() {
  const trackButtonClick = useCallback((eventName: string, properties?: TrackingProps) => {
    if (typeof window !== 'undefined' && posthog?.__loaded) {
      posthog.capture(eventName, properties)
    }
  }, [])

  const trackPlanSelection = useCallback((plan: 'monthly' | 'yearly', price: number, properties?: TrackingProps) => {
    if (typeof window !== 'undefined' && posthog?.__loaded) {
      posthog.capture('v2_plan_selected', {
        plan_type: plan,
        price,
        ...properties,
      })
    }
  }, [])

  return {
    trackButtonClick,
    trackPlanSelection,
  }
} 